
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataSuggestionsPage } from "reduxx/actions/pages/suggestions";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import apiRequest from 'utils/apiRequest';
import { SUGGESTIONS } from 'apis'; 

const Suggestions = () => {

    const dispatch = useDispatch();

    const { inputFullname, inputMobile, inputEmail, inputComment } = useSelector(state => state.suggestions);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        if(name === 'inputMobile')
            dispatch(handleChangeDataSuggestionsPage(name, changeNumberPersianAndArabic(value)));
        else
            dispatch(handleChangeDataSuggestionsPage(name, value));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };


    const handleSubmitForm = (event) => {
        event.preventDefault();

        if(inputFullname.trim().length < 3) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام و نام خانوادگی خود را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        }
        else if(inputMobile.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputMobile.trim().length !== 11)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت باید 11 رقم باشد  ', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputComment.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'متن نظر را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else {
            if(! isBackdropLoading) {
                apiRequest({
                    dispatch,
                    endpoint: SUGGESTIONS,
                    method: 'post',
                    data: { mobile: inputMobile, fullname: inputFullname, email: inputEmail, comment: inputComment },
                    token: null,
                    successMessage: 'با تشکر از شما، نظر شما با موفقیت ثبت شد',
                    onSuccess: (res) => {
                        dispatch(handleChangeDataSuggestionsPage('inputMobile', ''));
                        dispatch(handleChangeDataSuggestionsPage('inputFullname', ''));
                        dispatch(handleChangeDataSuggestionsPage('inputEmail', ''));
                        dispatch(handleChangeDataSuggestionsPage('inputComment', ''));
                        // navigate(`verify`);
                    },
                });
            }

        }
    };

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                
               <div className={[formStyles.title, formStyles['text-center'], formStyles['!text-primary']].join(' ')}>
                    هم وطن عزیز
                </div>


                <p className={ruleStyles['text-justify']}>
                    دکتربیست
                    <br />

                    بصورت فصلی (هرسه ماه یکبار) به بهترین پیشنهادی که منجر به <span className={formStyles.textSuccess}>افزایش بهره وری و کیفیت خدمات</span> گروه پزشکی Dr20 (نسخه الکترونیک و توریسم درمانی) گردد،جایزه نفیسی اهدا می‌کند.
                </p>


                <div className={[formStyles.title, formStyles['text-center'], formStyles['!text-primary'], sharedStyles['mt-[64px]']].join(' ')}>
                    پیشنهادات
                </div>

                <input type="text" name="inputFullname" value={inputFullname} onChange={handleChangeInputs} className={[formStyles.input, sharedStyles['mt-[16px]']].join(' ')} placeholder="نام و نام خانوادگی" />
                <input type="email" name="inputEmail" value={inputEmail} onChange={handleChangeInputs} className={formStyles.input} placeholder="ایمیل" />
                <input type="tel" name="inputMobile" value={inputMobile} onChange={handleChangeInputs} className={formStyles.input} placeholder="شماره موبایل" style={{direction: 'rtl'}} />
                <textarea rows={5} name="inputComment" value={inputComment} onChange={handleChangeInputs} className={formStyles.input} placeholder="متن پیشنهادات و انتقادات" />
                <button onClick={handleSubmitForm} className={formStyles.button}>ارسال</button>


            </div>
                
        </div>

    );
}

export default Suggestions;